import config from './routes.json';
import { SEO_SCHEMAS } from './schemas';

export const SITE_URL = config.siteUrl;
export const SITE_NAME = config.siteName;
export const DEFAULT_OG_IMAGE = config.defaultOgImage;
export const DEFAULT_OG_IMAGE_ALT = config.defaultOgImageAlt;
export const TWITTER_HANDLE = config.twitterHandle;
export const ROUTES = config.routes;
export const NOT_FOUND_META = config.notFound;
export const SITE_VERIFICATION = config.integrations?.siteVerification ?? {};
export const GA4_MEASUREMENT_ID = config.integrations?.analytics?.ga4MeasurementId ?? '';

/** Build an absolute URL on the canonical site origin from a path. */
export function absoluteUrl(pathOrUrl = '/') {
  if (!pathOrUrl) return `${SITE_URL}/`;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  if (path === '/') return `${SITE_URL}/`;
  return `${SITE_URL}${path.replace(/\/+$/, '')}`;
}

/**
 * Resolve the SEO metadata for a given pathname, collapsing dynamic
 * (`:code`) routes onto their canonical base route.
 */
export function getRouteMeta(pathname = '/') {
  const path = normalizePath(pathname);
  if (ROUTES[path]) {
    return { canonicalPath: path, ...ROUTES[path] };
  }
  for (const [prefix, base] of Object.entries(config.dynamicPrefixes || {})) {
    if (path.startsWith(prefix) && ROUTES[base]) {
      // Dynamic sub-routes point their canonical at the base route.
      return { canonicalPath: base, ...ROUTES[base] };
    }
  }
  return null;
}

/** Resolve page-level JSON-LD from the route registry schema key, if any. */
export function getRouteJsonLd(pathname = '/') {
  const schemaKey = getRouteMeta(pathname)?.jsonLdSchema;
  return schemaKey ? SEO_SCHEMAS[schemaKey] ?? null : null;
}

function normalizePath(pathname) {
  if (!pathname) return '/';
  const trimmed = pathname.split('?')[0].split('#')[0];
  if (trimmed.length > 1 && trimmed.endsWith('/')) {
    return trimmed.replace(/\/+$/, '');
  }
  return trimmed || '/';
}

export default config;
